var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWachtGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3073 15.5848C15.1708 15.7569 14.9219 15.7923 14.7564 15.6873L10.6873 12.7081C10.5791 12.6228 10.4585 12.4785 10.365 12.309C10.2697 12.1362 10.2184 11.9661 10.2184 11.8362V5.32427C10.2184 5.14821 10.3901 4.95773 10.6496 4.95773H11.9973C12.1985 4.95773 12.3639 5.12305 12.3639 5.32427V10.4566C12.3639 10.7114 12.4569 10.9744 12.5784 11.1949C12.7008 11.417 12.8679 11.625 13.0481 11.7649L13.048 11.7651L13.056 11.7708L16.0341 13.9168C16.2047 14.0531 16.238 14.3275 16.1108 14.4913L16.1107 14.4912L16.1064 14.4971L15.3073 15.5848ZM11.4841 22.725C5.2842 22.725 0.275 17.7158 0.275 11.5159C0.275 5.31503 5.28519 0.275 11.4841 0.275C17.684 0.275 22.725 5.31602 22.725 11.5159C22.725 17.7148 17.685 22.725 11.4841 22.725ZM11.4841 2.58063C6.58214 2.58063 2.61245 6.62034 2.61245 11.5169C2.61245 16.4162 6.58481 20.3886 11.4841 20.3886C16.3807 20.3886 20.4204 16.4189 20.4204 11.5169C20.4204 6.61766 16.3834 2.58063 11.4841 2.58063Z",
    fill: "#10A37F",
    stroke: "white",
    strokeWidth: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWachtGreen);
export default __webpack_public_path__ + "static/media/WachtGreen.ec5221f156d550d325bf9625a457b3d6.svg";
export { ForwardRef as ReactComponent };